import { getClinicAuthToken, getUserAuthToken, getBranchAuthToken } from '@/assets/js/auth'
import HttpRequest from './HttpRequest'

class getDataAccount extends HttpRequest {
  getDataAccount (query) {
    this.setHeader(getClinicAuthToken())// query userId
    return this.get('/v1/user-clinic', { ...query })
  }

  UpdateDataAccount (id, payload) {
    this.setHeader(getClinicAuthToken()) // params id not userId
    return this.patch(`/v1/user-clinic/${id}`, payload)
  }

  getDataCredit (query) {
    // this.setHeader(getUserAuthToken()) //query userId
    return this.get('/v1/credit-public', { ...query })
  }

  getDataAccountPassword (id, query) { // เส้นนี้ get password
    this.setHeader(getUserAuthToken()) // params id
    return this.get(`/v1/users/${id}`, { ...query })
  }

  changeAccountPassword (id, payload) { // เส้นนี้ Update PassWord
    this.setHeader(getUserAuthToken()) // params id
    return this.put(`/v1/users/${id}/password`, payload)
  }

  notification (query) {
    this.setHeader(getBranchAuthToken())
    return this.get('/v1/notification', { ...query })
  }

  readApi (query) {
    this.setHeader(getBranchAuthToken())
    return this.get('/v1/notification/read', { ...query })
  }

  readAllApi () {
    this.setHeader(getBranchAuthToken())
    return this.patch('/v1/notification/read-all', {}) // ส่ง body ว่าง
  }

  updateNotification (id, payload) {
    this.setHeader(getBranchAuthToken())
    return this.patch(`/v1/notification/${id}`, payload)
  }

  getPersonalReportDoctor (id, query) {
    this.setHeader(getBranchAuthToken())
    return this.get(`v1/report/report-doctor/${id}`, { ...query })
  }
}
export default getDataAccount
